// Notification API service
import { bubbleAPI } from './api';
import { BubbleNotification, Notification, transformNotification } from '../types/notification';
import logger from '../utils/logger';

export const notificationAPI = {
  // Get notifications for a user
  async getNotifications(userId: string): Promise<Notification[]> {
    try {
      const response = await bubbleAPI.post('/getmessage', {
        UserID: userId
      });

      const messages: BubbleNotification[] = response.data?.response?.Messages || [];
      return messages.map(transformNotification);
    } catch (error) {
      logger.error('Failed to fetch notifications:', error);
      throw error;
    }
  },

  // Mark notification as read
  async markAsRead(userId: string, notificationId: string): Promise<void> {
    try {
      await bubbleAPI.post('/messageread', {
        UserID: userId,
        NotificationID: notificationId
      });
    } catch (error) {
      logger.error('Failed to mark notification as read:', error);
      throw error;
    }
  }
};
